import Error from '../pages/Error';
import React from 'react';

import Cabinet from '../pages/Cabinet';
import Login from '../pages/Login';
import Devices from '../pages/Devices';
import {
    CABINET_ROUTE,
    DEVICES_ROUTE,
    LOGIN_ROUTE,
    MAIN_ROUTE,
    TEST_ROUTE,
    UNCKNOWN_ROUTE,
} from '../utils/consts';
import { Navigate } from 'react-router';
import NoAccess from '../pages/NoAccess';
import Test from '../pages/Test';

export const publicRoutes = [
    { path: MAIN_ROUTE, element: <Navigate to={LOGIN_ROUTE} replace />, exact: true },
    { path: LOGIN_ROUTE, element: <Login />, exact: true },
    { path: UNCKNOWN_ROUTE, element: <Error />, exact: true },
    { path: CABINET_ROUTE, element: <NoAccess />, exact: true },
    { path: DEVICES_ROUTE, element: <NoAccess />, exact: true },
    { path: DEVICES_ROUTE, element: <NoAccess />, exact: true },
    { path: TEST_ROUTE, element: <Test />, exact: true },
];

export const authRoutes = [
    { path: CABINET_ROUTE, element: <Cabinet />, exact: true },
    { path: DEVICES_ROUTE, element: <Devices />, exact: true },
];

